import { call, put, select, takeEvery } from "redux-saga/effects";
import { userSlice } from "./userReducer";
import { getRequest } from "./request";
import { failurePut } from "./failurePut";
import { IUserStatus } from "../modules/UserStatus/UserStatuses.t";
import { getAppUser } from "./appSelectors";
import _ from "lodash";

function* getUserStatusesSaga() {
    try {
        const data: IUserStatus[] = yield call(getRequest, `/user/statuses`);
        const userProfile = yield select(getAppUser);
        let flag = false;
        yield put(userSlice.actions.getUserStatusesSuccess(_.sortBy(data, 'pos').map(item => {
            const isCurrent = userProfile.user_status === item.status_name;
            if (!flag && isCurrent) flag = true;
            item.status_state = isCurrent ? 'progress' : flag ? 'plan' : 'completed';
            return item;
        })));
    } catch (e) {
        yield call(failurePut, e, userSlice.actions.getUserStatusesFailure);
    }
}

export function* userSagas() {
    yield takeEvery(userSlice.actions.getUserStatusesAction, getUserStatusesSaga);
}
